/**
 * GuideServiceInitializer
 *
 * Initializes the Guide Service integration with the Help Content Provider.
 * This component runs once on app mount to connect the guide system.
 */

import { useEffect } from 'react';
import { GuideService } from '@modules/firebase-core/services/GuideService';
import HelpContentProvider from '@modules/ui-components/services/HelpContentProvider';

export const GuideServiceInitializer = () => {
  useEffect(() => {
    // Initialize guide service
    const guideService = new GuideService();

    // Connect guide service to help content provider
    HelpContentProvider.getInstance().setGuideService(guideService);

    console.log('[GuideServiceInitializer] Guide service connected to help system');
  }, []); // Run once on mount

  // This is a logic-only component with no UI
  return null;
};

export default GuideServiceInitializer;
